module.exports = __webpack_public_path__ + "static/img/boardgameatlaslogo.09510412.png";